import { sendUtagEvent } from '../../core/analytics/utag_events'
import on from '../../utils/events_delegation'

/**
 * Initializes event tracking for utag events.
 * On desktop, the event is triggered by a `mouseover` with a debounce delay of 5 seconds.
 * If the user moves the mouse out and back in, the timer resets and the event can fire again.
 */
export function initializeUtagEvents() {
  const handlerFunctionMoreInfoClick = function () {
    const eventAct = this.closest('.utag-sustainable-info').dataset.utagEventLbl
    sendUtagEvent({
      data: {
        event_name: 'sustainability_module',
        event_cat: 'wave of change module',
        event_act: eventAct,
        event_lbl: 'more information',
        event_structure: 'body',
        event_purpose: 'inspiration',
      },
    })
  }

  on({
    eventName: 'click',
    selector: `.utag-sustainable-more-info`,
    handler: handlerFunctionMoreInfoClick,
  })
}
